export interface ApiRequestStatus {
  isLoading: boolean;
  isSuccess?: boolean;
  successMessage: string | null;
  errorMessage: string | null;
  errorHtml?: React.ReactNode | null;
  infoMessage?: string | null;
  nextToken?: string;
  headerMessage?: string;
}

export const initApiStatus: ApiRequestStatus = {
  isLoading: false,
  isSuccess: false,
  successMessage: null,
  errorMessage: null,
};
